var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    ref: "vselect",
    attrs: {
      options: _vm.selectOptions,
      "on-change": _vm.onChange,
      clearSearchOnSelect: true,
      value: _vm.selectedOption,
      loading: _vm.loading,
      selectOnTab: true
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8fb0c0ae", { render: render, staticRenderFns: staticRenderFns })
  }
}